<ng-container *ngIf="viewModel$ | async">
  <mmx-breadcrumbs
    *ngIf="!embedded && !shopper"
    [breadcrumbs]="[patient, estimate]"
  >
  </mmx-breadcrumbs>

  <mmx-shopper-patient-form
    *ngIf="shopper"
    [readonly]="!showEstimateInputs"
  ></mmx-shopper-patient-form>

  <ng-container *ngIf="showEstimateInputs">
    <mmx-estimate-charges
      [estimate]="estimateService.estimate$ | async"
      [estimateForm]="estimateService.estimateForm"
      [estimateChargesLoading]="estimateService.estimateChargesLoading$ | async"
      [claimSearchEnabled]="estimateService.claimSearchEnabled$ | async"
      [appointmentOptions]="estimateService.appointmentOptions$ | async"
      [allAppointments]="(estimateService.allAppointments$ | async) ?? []"
      [shopper]="shopper"
      (resetEstimateForm)="onResetEstimateForm($event)"
      (claimAdded)="estimateService.addClaim($event)"
      (addChargeDiscountControl)="
        estimateService.onAddChargeDiscountControl($event.index, $event.type)
      "
      (removeChargeDiscountControl)="
        estimateService.onRemoveChargeDiscountControl($event.index)
      "
      (loadTemplate)="estimateService.loadTemplate($event)"
      (facilityChanged)="onFacilityChanged($event)"
      (chargesCleared)="onChargesCleared()"
      (templateSaved)="onTemplateSaved($event)"
      (addChargesRequested)="onAddChargesRequested($event)"
      (dirty)="onDirty()"
    ></mmx-estimate-charges>

    <mmx-shopper-insurance-card
      *ngIf="shopper"
      [shopperInsurances]="estimate?.shopperInsurances"
      (insuranceChanged)="onShopperInsuranceChanged($event)"
    ></mmx-shopper-insurance-card>

    <ng-container *ngIf="!shopper">
      <ng-container *mmxHasAccess="['patient-insurance.view']">
        <mmx-insurances-card></mmx-insurances-card>
      </ng-container>
    </ng-container>

    <mmx-estimate-benefits *ngIf="estimate && (!shopper || hasShopperInsurance)" [shopper]="shopper"></mmx-estimate-benefits>
  </ng-container>

  <ng-container *appHasModule="'charityCare'">
    <mmx-expandable-card *ngIf="!shopper" [title]="'charity-care-summary.title'">
      <mmx-charity-care-summary
      [patientCharityCareStatus]="patient?.patientCharityCareStatus"
      [timezone]="facility?.timezone"
      [patientId]="patient?.id"
      ></mmx-charity-care-summary>
    </mmx-expandable-card>
  </ng-container>

  <mmx-estimate-summary
    [embedded]="embedded"
    [shopper]="shopper"
    [estimate]="estimateService.estimate$ | async"
    [patient]="patient"
    [shopperInsurances]="estimate?.shopperInsurances"
    [shopperEligibilityId]="estimate?.eligibilityId"
    (estimateDeleted)="onEstimateDeleted()"
  ></mmx-estimate-summary>
</ng-container>
